import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import ActivityInfoList from './activity-info-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Activity Infos">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Activities</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <ActivityInfoList />
    </Panel>
  );
};

export default Page;
